import * as React from "react";
import "./styles.scss";

export interface ITextField {
    label?: string;
    error?: string;
    value: string | number;
    disabled?: boolean;
    placeholder?: string;
    fieldName: string;
    onChange: (fieldName: string, value: string | number) => void;
    type: string;
    containerClass?: string;
    inputTextClass?: string;
    iconClass?: string;
    iconClickHandler?: (fieldName: string) => void;
}
interface IDropDownOption {
    name: string;
    value: string;
}
export interface ISelect {
    label?: string;
    error?: string;
    value: string | number;
    options: IDropDownOption[];
    disabled?: boolean;
    fieldName: string;
    onChange: (fieldName: string, value: string | number) => void;
}

export function TextField(props: ITextField) {
    return (
        <div className={props.containerClass ? props.containerClass : "input-style mt-2 mb-2"}>
            <div className="float-left">
                <span className="text-input-label">{props.label}</span>
            </div>
            <div className="input-style-2">
                <i onClick={() => props.iconClickHandler(props.fieldName)} className={`input-icon float-right ${props.iconClass}`}/>
                <input type={props.type}
                       name={props.fieldName}
                       className={`${props.inputTextClass ? props.inputTextClass : "form-control input-text"} ${props.error ? "border-danger" : "border-dark"}`}
                       value={props.value !== null ? props.value : ""}
                       onChange={(e) => props.onChange(props.fieldName, e.target.value)}
                       disabled={props.disabled ? props.disabled : false}
                       placeholder={props.placeholder ? props.placeholder : ""}
                />
            </div>
                {props.error && props.error.trim() !== "" && <div className="float-left text-danger error-text pt-1 ">
                {props.error}
            </div>}
        </div>
    );
}

export function Select(props: ISelect) {
    return (
        <div className="input-style mt-2 mb-2">
            <div className="float-left">
                <span>{props.label}</span>
            </div>
            {props.error && props.error.trim() !== "" && <div className="float-right error-color">
                {props.error}
            </div>}
            <select
                value={props.value !== null ? props.value : ""}
                className={`input-text ${props.error && props.error.trim() !== "" ? "error-border" : null}`}
                onChange={(e) => props.onChange(props.fieldName, e.target.value)}
                disabled={props.disabled ? props.disabled : false}
            >
                {props.options.map((option, index: number) => {
                    return <option key={index} value={option.value}>{option.name}</option>
                })}
            </select>
        </div>
    );
}
